import {GeneralAction} from '../../../@types/actions';
import {NEW_BOOKED_EVENT} from '../../../constants/MonitorConstants';

export const NewBookedEventAction = ({book}: { book: string }): GeneralAction => ({
    type: NEW_BOOKED_EVENT,
    payload: book
});
